import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { IUser } from "../../models/IUser";
import { IUserPermission } from "../../models/IUserPermission";
import { createBrowserHistory } from "history";
import { AppDependencies } from "../../services/appDependencies";

const history = createBrowserHistory();

interface AccountState {
  token?: string;
  tokenExpire?: string;
  user?: IUser;
  userPermissions: IUserPermission[];
  loginStatus: "none" | "pending" | "fulfilled" | "rejected";
  loading: boolean;
}

const initialState: AccountState = {
  userPermissions: [],
  loginStatus: "none",
  loading: false,
};

export const signInUser = createAsyncThunk(
  "account/signIn",
  async (data: any, thunkAPI) => {
    try {
      const tokenData = await AppDependencies.AccountService.login(
        data.userName,
        data.password,
      );
     if (tokenData) {
localStorage.setItem("token", tokenData.token);
return tokenData.token;
     }
      return thunkAPI.rejectWithValue({ error: "unauthorized" });
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: "unauthorized" });
    }
  }
);

export const fetchCurrentUser = createAsyncThunk(
  "account/fetchUser",
  async (thunkAPI) => {
    try {
      const user = await AppDependencies.AccountService.currentUser();
      return user;
    } catch (error) {
      //@ts-ignore
      return thunkAPI.rejectWithValue({ error: error.data });
    }
  }
);

export const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    doLogout: (state) => {
      state.token = undefined;
      state.user = undefined;
      state.userPermissions = [];
      localStorage.removeItem("token");
    },
  },
  extraReducers: (builder) => {
     builder.addMatcher(isAnyOf(fetchCurrentUser.fulfilled), (state, action) => {
       const userData = action.payload;
         let roles = userData["roles"];
         if (typeof roles === "string") {
           roles = [roles];
         }
         state.user = {
           userName: userData["UserName"],
           employeeId: userData["EmployeeId"],
           departmentId: userData["DepartmentId"],
           lockoutEnabled: false,
           roles,
         };
         console.log(roles)
         state.userPermissions =
           AppDependencies.PermissionService.getPermissionsByRole(roles);
         
      
       state.loading = false;
     });

    builder.addMatcher(isAnyOf(fetchCurrentUser.fulfilled), (state, action) => {
      const user = action.payload;
      if (user) {
        state.user = { ...user };
      }
      state.loading = false;
    });

    builder.addMatcher(
      isAnyOf(signInUser.pending
      ),
      (state) => {
        state.loginStatus = "pending";
        state.loading = true;
      }
    );

    builder.addMatcher(
      isAnyOf(signInUser.rejected, fetchCurrentUser.rejected),
      (state) => {
        state.loginStatus = "rejected";
        state.loading = false;
      }
    );
    builder.addMatcher(
      isAnyOf(signInUser.fulfilled),
      (state) => {
        state.loginStatus = "fulfilled";
        state.loading = false;
      }
    );
  },
});

export const { doLogout } = accountSlice.actions;

export const selectAuthToken = (state: RootState) => state.account.token;
export const selectAuthUser = (state: RootState) => state.account.user;
export const selectUserPermissions = (state: RootState) =>
  state.account.userPermissions;
export const selectLoginStatus = (state: RootState) =>
  state.account.loginStatus;
export const selectLoading = (state: RootState) => state.account.loading;

export const account = accountSlice.reducer;
//
// // First, create the thunk
// const fetchUserById = createAsyncThunk(
//     'users/fetchByIdStatus',
//     async (userId: number, thunkAPI) => {
//         // const response = await userAPI.fetchById(userId)
//         // return response.data
//     }
// )

// const login = createAsyncThunk(
//     "account/login",
//     async (loginDto: ILoginRequestDto, thunkAPI) => {
//
//     }
// );
//
// interface UsersState {
//     entities: any[]
//     loading: 'idle' | 'pending' | 'succeeded' | 'failed'
// }
//
// const initialState = {
//     entities: [],
//     loading: 'idle',
// } as UsersState
//
// // Then, handle actions in your reducers:
// const usersSlice = createSlice({
//     name: 'users',
//     initialState,
//     reducers: {
//         // standard reducer logic, with auto-generated action types per reducer
//     },
//     extraReducers: (builder) => {
//         // Add reducers for additional action types here, and handle loading state as needed
//         builder.addCase(fetchUserById.fulfilled, (state, action) => {
//             // Add user to the state array
//             state.entities.push(action.payload)
//         })
//     },
// })
//
// // export const {setUser, logout} = accountSlice.actions;
// // export const selectUser = (state: RootState) => state.account.user === null ? null : JSON.parse(state.account.user);
// // Later, dispatch the thunk as needed in the app
// // dispatch(fetchUserById(123))
